import { apiActions, commonActions } from '../app/actions';
import { makeRequest } from '../lib/fetch';
import { fireMessageEvent } from '../messenger/utils';

export const playersPicked = () => (dispatch) => {
  const { setValue } = commonActions('player_picks_submitted');
  dispatch(setValue());
};

export const noContestToday = () => (dispatch) => {
  const { setValue } = commonActions('no_contest_today');
  dispatch(setValue());
};

export const playerPicksSubmitted = (picks) => (dispatch) => {
  const { setValue } = commonActions('player_picks_submitted');
  dispatch(setValue(picks));
};

export const fetchPlayerData = () => (dispatch, getState) => {
  const { config } = getState();
  const { apiUrl, env, userId, currentSession, platform } = config;

  const { fetchStart, fetchSuccess, fetchFailure } = apiActions('player_data');

  dispatch(fetchStart());

  return makeRequest({
    method: 'GET',
    route: 'players',
    apiUrl,
    env,
    userId,
    currentSession,
    // ...(env === 'dev' && {
    //   headers: {
    //     mockresponse: 'get-games-error',
    //   },
    // }),
  }).then(
    (resp) => {
      if (resp.code === 'serverError') {
        return dispatch(fetchFailure(resp));
      }

      if (resp.code === 'noContest') {
        return dispatch(noContestToday());
      }

      if (resp.picks) {
        return dispatch(playerPicksSubmitted(resp));
      }

      return dispatch(fetchSuccess(resp));
    },
    (err) => {
      const messageData = {
        err,
        route: 'players',
        apiUrl,
        userId,
        currentSession,
      };
      fireMessageEvent({
        type: 'ERROR',
        platform,
        title: 'hockey-challenge-error',
        data: messageData,
      });
      if (err?.status !== 401) {
        dispatch(fetchFailure(err));
      }

      return dispatch(apiActions('data_500').fetchFailure(err));
    },
  );
};
